import { IPalettes, IPaletteSettings, SidebarStateEnum } from '../types';

export enum ExportStatusEnum {
  READY_TO_START,
  STARTED,
  DONE,
}

export enum ActionTypesEnum {
  SET_PALETTES,
  SET_PALETTE_SETTINGS,
  SET_SIDEBAR_STATE,
  ADD_APP_STATE,
  GO_PREV_VERSION,
  GO_NEXT_VERSION,
  SET_EXPORT_STATUS,
}

export interface IStateModel {
  hasUrlColors: boolean;
  paletteSettings: IPaletteSettings;
  palettes: IPalettes;
  sidebarState?: SidebarStateEnum;
  appState: {
    palettes: IPalettes;
  }[];
  appStateVersion: number;
  exportStatus: ExportStatusEnum;
}

export interface IActionModel {
  type: ActionTypesEnum;
  payload?: any;
}
